<template>
	<div>
		<teach-tvideo-content></teach-tvideo-content>
	</div>
</template>

<script>
	import TeachTvideoContent from '@/pages/teach/components/TeachTvideoContent'
	import axios from 'axios'
	export default {
		name: 'TeachTvideo',
		components: {
			TeachTvideoContent
		},
		data() {
			return {}
		},
		methods: {},
		mounted() {}
	};
</script>

<style>

</style>